import React from 'react';
import ResponsiveSelect from './ResponsiveSelect';

interface Option {
  value: string | number;
  label: string;
}

interface SelectProps {
  label?: string;
  options: Option[];
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  className?: string;
  fullWidth?: boolean;
}

export default function Select({
  label,
  options,
  value,
  onChange,
  placeholder = 'Select an option',
  required = false,
  disabled = false,
  error,
  className = '',
  fullWidth = true,
}: SelectProps) {
  const widthClass = fullWidth ? 'w-full' : '';
  const errorClass = error ? 'border-red-500 focus:ring-red-500' : 'border-ink-200 focus:ring-brand-500';
  const disabledClass = disabled ? 'bg-ink-50 cursor-not-allowed' : 'bg-white';

  return (
    <div className={`${widthClass} ${className}`}>
      {label && (
        <label className="block text-sm font-semibold text-ink-700 mb-1.5">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <ResponsiveSelect
        value={value}
        onChange={(val) =>
          onChange({ target: { value: val } } as React.ChangeEvent<HTMLSelectElement>)
        }
        placeholder={placeholder}
        disabled={disabled}
        options={options}
        className={`
          ${widthClass}
          px-3 py-2.5 border rounded-xl min-h-[44px] lg:min-h-0
          ${errorClass}
          ${disabledClass}
        `}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
